// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mGnV","option":"styles_option__2D4o3","selected":"styles_selected__2RASu"};